export const API_ENDPOINTS = {
  SIGNUP: "/auth/signup",
  LOGIN: "/auth/login",
  USER_PROFILE: "/user/profile",
  GOOGLE_LOGIN: "/auth/google-auth",
  FORGOT_PASSWORD: "/auth/forgot-password",
  OTP_VERIFCATION: "/auth/verify-otp-for-forgot-password-user",
  CHANGE_PASSWORD: "/auth/change-password-user",
  GET_PRODUCTS: "/products",
  GET_CART: "/cart",
  ADD_TO_CART: "/cart/add",
  UPDATE_CART: "/cart/update",
  REMOVE_FROM_CART:"/cart/remove",
  CREATE_ORDER:"/orders/create",
  GET_ORDER_HISTORY:"/orders/history",
  UPDATE_USER: "/auth/user", 
  ADD_ADDRESS: "/api/addresses/add",
  GET_ADDRESSES: "/api/addresses", 
  UPDATE_ADDRESS: "/api/addresses/update",
  DELETE_ADDRESS: "/api/addresses/delete",   
  OTP_VERIFCATION_SIGNUP: "/auth/verify-otp-for-signup",    
  UPDATE_PROFILE: "/auth/user/:id", 
  VERIFY_PAYMENT: "/orders/verify-payment",
  CREATE_RAZORPAY_ORDER: "/orders/create-razorpay-order",
}